var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAgeOver18(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "56px",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "age_over_18") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "40.8164202%",
    y1: "-5.10147856%",
    x2: "63.7753696%",
    y2: "100.509689%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE243A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5243F",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "age_over_18",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle963",
    fill: "#D4253D",
    opacity: 0.201423282,
    cx: 28,
    cy: 28,
    r: 28
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle967",
    fill: "url(#linearGradient-1)",
    cx: 28,
    cy: 28,
    r: 21.778
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.819,19.968 L21.819,37 L18.656,37 L18.656,22.62 L15.055,22.62 L15.055,19.968 L21.819,19.968 Z M36.244,28.046 C37.137,28.451 37.818,29.003 38.288,29.7 C38.775,30.382 39.018,31.185 39.018,32.11 C39.018,33.147 38.726,34.056 38.142,34.834 C37.575,35.614 36.764,36.214 35.709,36.635 C34.655,37.041 33.43,37.243 32.035,37.243 C30.64,37.243 29.415,37.041 28.361,36.635 C27.323,36.213 26.52,35.613 25.952,34.835 C25.384,34.055 25.1,33.147 25.1,32.109 C25.1,31.185 25.336,30.382 25.806,29.7 C26.276,29.003 26.95,28.451 27.826,28.046 C27.144,27.673 26.617,27.186 26.244,26.586 C25.887,25.969 25.709,25.264 25.709,24.469 C25.709,23.512 25.969,22.676 26.487,21.963 C27.023,21.249 27.769,20.698 28.726,20.308 C29.683,19.918 30.786,19.724 32.036,19.724 C33.3,19.724 34.411,19.919 35.368,20.308 C36.326,20.698 37.072,21.249 37.608,21.963 C38.142,22.676 38.41,23.512 38.41,24.469 C38.41,25.264 38.224,25.961 37.85,26.562 C37.477,27.162 36.942,27.657 36.245,28.046 L36.244,28.046 Z M32.035,22.206 C31.045,22.206 30.259,22.417 29.675,22.839 C29.107,23.261 28.823,23.853 28.823,24.615 C28.823,25.345 29.107,25.929 29.675,26.367 C30.259,26.789 31.045,27 32.035,27 C33.041,27 33.835,26.789 34.42,26.367 C35.004,25.929 35.296,25.345 35.296,24.615 C35.296,23.853 34.996,23.26 34.396,22.839 C33.811,22.417 33.025,22.206 32.036,22.206 L32.035,22.206 Z M32.035,34.761 C33.203,34.761 34.128,34.518 34.809,34.031 C35.49,33.545 35.831,32.871 35.831,32.011 C35.831,31.168 35.491,30.503 34.809,30.017 C34.128,29.53 33.203,29.287 32.035,29.287 C30.867,29.287 29.951,29.53 29.285,30.017 C28.621,30.503 28.288,31.168 28.288,32.012 C28.288,32.872 28.621,33.545 29.286,34.032 C29.951,34.518 30.867,34.762 32.036,34.762 L32.035,34.761 Z",
    id: "path969",
    fill: "#FFFFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgeOver18);
export default __webpack_public_path__ + "static/media/age_over_18.18e23e07b6a415d2d40009cd0b7eb5d4.svg";
export { ForwardRef as ReactComponent };